import { render, staticRenderFns } from "./WaitingListWrapUp.vue?vue&type=template&id=76d99c72&scoped=true&"
import script from "./WaitingListWrapUp.vue?vue&type=script&lang=ts&"
export * from "./WaitingListWrapUp.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingListWrapUp.vue?vue&type=style&index=0&id=76d99c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d99c72",
  null
  
)

export default component.exports